import { render } from "./NoahMain.vue?vue&type=template&id=20262c00&scoped=true"
import script from "./NoahMain.vue?vue&type=script&lang=js"
export * from "./NoahMain.vue?vue&type=script&lang=js"

import "./NoahMain.vue?vue&type=style&index=0&id=20262c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20262c00"]])

export default __exports__